import { render, staticRenderFns } from "./01.vue?vue&type=template&id=77bc6f62&scoped=true"
import script from "./01.vue?vue&type=script&lang=js"
export * from "./01.vue?vue&type=script&lang=js"
import style0 from "./01.vue?vue&type=style&index=0&id=77bc6f62&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc6f62",
  null
  
)

export default component.exports